<template>
  <div class="Checkout">
    <b-container>
        <div class="contentBlock" v-html="content"></div>

    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Checkout',
  components: {
  },
  data: function() {
    return {
      acf: [],
      content: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'imsim-uk' + "/wp-json/wp/v2/pages/209" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.content = response.data.content.rendered,
            console.log("this.content"),
            console.log(this.content)
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
    .contentBlock {
        height: 500px;
        color: #000;
        font-weight: bold;
        font-size: 30pt;
    }
</style>
